<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Marketing Cluster 🗣️</h1>
        <h4>The Marketing Cluster acts as the intermediary for non-IM-related initiatives between MISA and external entities such as corporate institutions and organizations within and outside the Ateneo campus. Its primary role is to assist the organization and its respective events, through the provision of corporate and student organizational partnerships.</h4>

        <h3>Positions:</h3>

        <h2><b>Senior Relations Manager</b></h2>
        <h4>All the Senior Relations Managers can undergo the role rotation program between the three sub-clusters to allow each officer to be well-versed in each aspect necessary in the cluster, thus giving each Senior Relations Manager the role as Senior Corporate / Organizational / Alumni Relations Manager. Each Senior Relations Manager will be assigned to a specific sub-cluster for a period of two to four months depending on the Vice President’s discretion in aligning the rotation period to MISA’s calendar of events.</h4>
        
       <h3><b>Senior Corporate Relations Manager</b></h3>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Works closely with the Associate Vice President for Corporate Relations, wherein s/he assists in drafting contracts and proposals in relation to Corporate Partners</li>
            <li>More importantly, s/he is in charge of aiding the Associate Vice Presidents and the Vice President in creating and maintaining relationships with Corporate Partners and overseeing training for the Marketing Officers</li>
        </ul>

        <h3><b>Senior Organizational Relations Manager</b></h3>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Works closely with the Associate Vice President for Organizational Relations, wherein s/he assists in drafting contracts and proposals in relation to Organizational Partners</li>
            <li>More importantly, s/he is in charge of aiding the Associate Vice Presidents and the Vice President in creating and maintaining relationships with the Organizational Partners and overseeing training for the Marketing Officers</li>
        </ul>

        <h3><b>Senior Alumni Relations Manager</b></h3>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Works closely with the Associate Vice President for Alumni Relations, wherein s/he assists in planning for Networking Night Event/s as Deputy Project Director and in inviting alumni to various MISA events</li>
            <li>More importantly, s/he is in charge of aiding the Associate Vice Presidents and the Vice President in creating and maintaining relationships with the Alumni and overseeing training for the Marketing Officers</li>
        </ul>

        <h2><b>Marketing Officer</b></h2>
        <h4>The Marketing Officer is in charge of looking for possible sponsors and partners for the event. They will also serve as the contact person for the corresponding sponsors and partners and will also be in charge of drafting the Memorandum of Agreement (MOA). He/She directly works for VP for Marketing, Assigned AVP for Corporate Relations, and Project Core Team. </h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Serve as contact persons for sponsors assigned</li>
            <li>In charge of looking for potential sponsors</li>
            <li>Assist in handling and maintaining the sponsor database</li>
            <li>Drafts and sends MOAs to sponsors</li>
            <li>In charge of making sure that MOAs are followed</li>
            <li>In charge of communicating with Programs and Creatives for any partner-related concerns (i.e., verbal acknowledgments, company logo inclusion in posters and/or presentations)</li>
            <li>In charge of distributing ex-deals to participants during the event day and sending giveaway vouchers/prices via email (if applicable)</li>
            <li>Drafts the post-activity reports after the event and sends them to sponsors</li>
        </ul>
        <h4>Qualifications:</h4>
        <ul>
            <li>Sociable in contacting people</li>
            <li>Able to negotiate deals when needed</li>
            <li>Good communication skills</li>
            <li>Prompt with deadlines</li>
            <li>Has initiative and assertive</li>
        </ul> 

        <!--
        <h2><b>NetNight Volunteers Pool</b></h2>
        <h4>Networking Night 2023 is an on-campus event to be held this February that aims to provide an avenue for the MIS community to learn more about the industry and to make meaningful connections with other participants. Volunteers can choose or will be assigned to any of the following tasks:</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Event registration and ushering</li>
            <li>Decorations</li>
            <li>Preparation of event materials</li>
            <li>Documentation</li>
            <li>Arrangement of food and drinks for the participants and other onsite event duties</li>
        </ul>

        <h2><b>NetNight Facilitators</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Assigned to different Networking Night tables, each with a corresponding topic.</li>
            <li>In charge of ensuring that participants at their tables are introduced to each other and that the conversations flow easily. *Keep track of the time left for the networking sessions.</li>
        </ul>  -->

        <!-- BETA POSITIONS -->
        <!-- <h2><b>Associate Vice President for Corporate Relations (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Creates, negotiates, maintains deals and agreements, and communicates with MISA’s Corporate Partners who will be potential sponsors providing the organization with additional resources and financial assistance in MISA events and projects</li>
            <li>Ensures that all deliverables in the corporate partnerships are followed</li>
            <li>Trains, oversees, deploys, and communicates with the Senior Corporate Relations Manager/s and the Marketing Officers under the Corporate Relations sub-cluster, and serves as the bridge between them and the Vice President for Marketing</li>
        </ul>

        <h2><b>Associate Vice President for Organizational Relations (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Maintains and builds relationships with various organizations within and outside the Ateneo on MISA’s behalf </li>
            <li>Has the responsibility of familiarizing and interacting with other organizations both inside and outside of Ateneo </li>
            <li>Ensures that all the deliverables in the organizational partnerships are followed </li>
            <li>Trains, oversees, deploys, and communicates with the Senior Organizational Relations Manager/s and the Marketing Officers under the Organizational Relations sub-cluster, and serves as the bridge between them and the Vice President for Marketing </li>
        </ul>

        <h2><b>Associate Vice President for Alumni Relations (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Contacts and maintains relations with the alumni of the organization</li>
            <li>Heads the MISA Networking Night event throughout the year as its Project Director</li>
            <li>Plans and executes MISA Tambayan sa RLAB Podcast; communicates with Events for the HEX Episodes</li>
            <li>Invites the alumni to various events of MISA and attains possible partnerships with companies that the alumni may be affiliated with</li>
            <li>Trains, oversees, deploys, and communicates with the Senior Alumni Relations Manager/s and the Marketing Officers under the Alumni Relations sub-cluster, and serves as the bridge between them and the Vice President for Marketing</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerMarketing'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>
